import React, { useState, useEffect } from "react";
import { Skeleton } from "primereact/skeleton";
// icons
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import { Link, NavLink } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import {
  activatePassword_allRight,
  desactivePassword_secure,
  getAbonneInfo_allRight,
  getAbonneInfo_secure,
} from "../../../services/abonne/AbonneRequest";
import { isPasswordDefine } from "../../../utils/AuthGuard";
import axios from "axios";

const Profil = () => {
  const [loading, setLoading] = useState(false);
  const [loadingReq, setLoadingReq] = useState(false);
  const [activationMessage, setActivationMessage] = useState(false);
  const [desactivationMessage, setDesactivationMessage] = useState(false);
  const [user, setUser] = useState({});
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [desactivePassword, setDesactivePassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [userNotAllow, setUserNotAllow] = useState("");
  const [userPhoneNumber, setUserPhoneNumber] = useState("");
  const [message, setMessage] = useState("");

  const addPassword = () => {
    try {
      setLoading(true);
      setErrorMessage(null);

      const data = {
        newPassword: password,
        numero: user.numero,
        password: password,
        passwordConfirm: confirmPassword,
      };

      if (password.length >= 6) {
        if (password === confirmPassword) {
          activatePassword_allRight(data)
            .then((res) => {
              setLoading(false);
              setActivationMessage(true);
              setDesactivationMessage(false);
              sessionStorage.setItem("token", res.data.donnee.accessToken);
              console.log("ADD PASSWORD", res.data.donnee);
              document.getElementById("modal-add-password").click();
              showModalSuccess();
              setPassword("");
              setConfirmPassword("");
              getUserAccountSecureDetail();
            })
            .catch((err) => {
              setLoading(false);
              console.log("api err", err);
              setErrorMessage("Une erreur s'est produite, rééssayer !");
            });
        } else {
          setLoading(false);
          setErrorMessage("Les mots de passe ne sont pas identique");
        }
      } else {
        setLoading(false);
        setErrorMessage("Le mot de passe doit contenir au moins 6 caractères");
      }
    } catch (error) {
      setLoading(false);
      console.log("catch err", error);
    }
  };

  const desactivatePassword = () => {
    try {
      setLoading(true);
      setErrorMessage("");
      const data = {
        password: desactivePassword,
      };

      desactivePassword_secure(data)
        .then((res) => {
          setLoading(false);
          setActivationMessage(false);
          setDesactivationMessage(true);
          sessionStorage.removeItem("token");
          document.getElementById("modal-remove-password").click();
          showModalSuccess();
          setErrorMessage("");
          setDesactivePassword("");

          getUserAccountAllDetail();
        })
        .catch((err) => {
          setLoading(false);
          setErrorMessage(err.response.data.donnee);
        });
    } catch (error) {
      setLoading(false);
      console.log("catch error", error);
      setErrorMessage("Essayer plus tard");
    }
  };

  const getUserAccountSecureDetail = () => {
    const customerNumber = sessionStorage.getItem('customer_number') ? sessionStorage.getItem('customer_number') : ""
    getAbonneInfo_secure(customerNumber)
      .then((res) => {
        setLoading(false);
        setUser(res.data.donnee);
      })
      .catch((err) => {
        setLoading(false);
        console.log("api error", err);
        setErrorMessage("Une erreur s'est produite, rééssayer !");
      });
  };

  const getUserAccountAllDetail = () => {
    const customerNumber = sessionStorage.getItem('customer_number') ? sessionStorage.getItem('customer_number') : ""
    getAbonneInfo_allRight(customerNumber)
      .then((res) => {
        setLoading(false);
        setUser(res.data.donnee);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const showModalSuccess = () => {
    document.getElementById("success-password").click();
  };

  const findUserInfo = () => {
    sessionStorage.setItem("customer_number", userPhoneNumber);
    setLoadingReq(true)
    getAbonneInfo_allRight(userPhoneNumber)
      .then((res) => {
        setUser(res.data.donnee);
        setLoadingReq(false)
        sessionStorage.setItem("user", JSON.stringify(res.data.donnee));
        if (
          !sessionStorage.getItem("presence") &&
          sessionStorage.getItem("token")
        ) {
          document.getElementById("btn-alert").click();
          sessionStorage.setItem("presence", true);
        } else if (
          !sessionStorage.getItem("presence") &&
          !sessionStorage.getItem("token")
        ) {
          document.getElementById("btn-alert").click();
        }
        document.getElementById("alert-modal-enter-number").click();
      })
      .catch((err) => {
        setLoadingReq(false)
        document.getElementById("alert-modal-enter-number").click();
        if (err.response && err.response.data.statut === 1) {
          setUserNotAllow(err.response.data.donnee);
          document.getElementById("alert-modal-not-allow").click();
        } else if (err.response && err.response.data.statut === 2 && !sessionStorage.getItem('customer_number')) {
          setMessage(err.response.data.donnee);
          document.getElementById("alert-modal-enter-number").click();
        }
      });
  };

  useEffect(() => {
    try {
      const customerNumber = sessionStorage.getItem('customer_number') ? sessionStorage.getItem('customer_number') : ""
      if (isPasswordDefine()) {
        getAbonneInfo_secure(customerNumber)
          .then((res) => {
            setLoading(false);
            setUser(res.data.donnee);
          })
          .catch((err) => {
            setLoading(false);
            console.log("api error", err);
          });
      } else {
        getAbonneInfo_allRight(customerNumber)
          .then((res) => {
            setUser(res.data.donnee);
          })
          .catch((err) => {
            console.log("api error", err);
            if (err.response && err.response.data.statut === 1) {
              setUserNotAllow(err.response.data.donnee);
              document.getElementById("alert-modal-not-allow").click();
            } else if (err.response && err.response.data.statut === 2 && !sessionStorage.getItem('customer_number')) {
              setMessage(err.response.data.donnee);
              document.getElementById("alert-modal-enter-number").click();
            }
          });
      }
    } catch (error) {
      console.log("catch err", error);
    }
  }, []);

  return (
    <div className="h-full pt-5 sm:pt-8">
      <div>
        <div className="flex justify-end lg:w-11/12 mx-auto px-2 sm:px-5 lg:px-10">
          <Link to="/forfaits/acheter">
            <button className="bg-black text-jaune-mtn w-16 h-8 text-sm">
              Retour
            </button>
          </Link>
        </div>
        <div className="relative lg:w-11/12 mx-auto pt-5 px-2 sm:px-5 lg:px-10 flex items-center justify-between">
          <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-black">
            Y'ello
          </h1>
          {user && user.Solde ? (
            <h1 className="text-base sm:text-xl md:text-2xl font-bold text-black">
              Solde : {user.Solde} FCFA
            </h1>
          ) : null}
          {!user.Solde ? (
            <div className="flex items-center gap-x-2">
              <h1 className="text-base sm:text-xl md:text-2xl font-bold text-black">
                Solde :
              </h1>
              <Skeleton
                width="3.5rem"
                height="1rem"
                borderRadius=".3rem"
              ></Skeleton>
            </div>
          ) : null}
        </div>
        <div className="lg:w-11/12 mx-auto px-2 sm:px-5 lg:px-10 md:flex items-start justify-between mt-8 sm:mt-14 pb-12 border-b-2 border-b-gray-200">
          <div className="w-full lg:w-1/2 flex items-start gap-x-4">
            <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-gray-mtn flex items-center justify-center">
              <SmartphoneIcon />
            </div>
            <div>
              <div className="mt-2">
                <p className="uppercase font-medium text-gray-400 text-sm">
                  Mon numéro
                </p>
                {user && user.numero ? (
                  <p className="font-medium text-sm sm:text-base">
                    {user.numero}
                  </p>
                ) : null}
                {!user.numero ? (
                  <Skeleton height="1rem" borderRadius=".3rem"></Skeleton>
                ) : null}
              </div>
              <div className="mt-3">
                <p className="uppercase font-medium text-gray-400 text-sm">
                  Profil
                </p>
                {user && user.profil ? (
                  <p className="font-medium text-sm sm:text-base">
                    {user.profil}
                  </p>
                ) : null}
                {!user.profil ? (
                  <Skeleton height="1rem" borderRadius=".3rem"></Skeleton>
                ) : null}
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/2 mt-8 lg:mt-0">
            <div className="w-full flex flex-col gap-y-4">
              {!user.motdepasseisactif ? (
                <label
                  htmlFor="modal-add-password"
                  className="w-full h-10 rounded-full flex items-center justify-center text-xs sm:text-sm bg-black text-jaune-mtn font-bold outline-none cursor-pointer"
                >
                  <span>Activer mot de passe</span>
                </label>
              ) : (
                <label
                  htmlFor="modal-remove-password"
                  className="w-full h-10 rounded-full flex items-center justify-center text-xs sm:text-sm bg-black text-jaune-mtn font-bold outline-none cursor-pointer flex items-center justify-center"
                >
                  <span>Désactiver mot de passe</span>
                </label>
              )}
              {user.motdepasseisactif ? (
                <NavLink to="/compte/password">
                  <button className="w-full h-10 rounded-full text-xs sm:text-sm text-white bg-black font-bold outline-none">
                    Modifier mot de passe
                  </button>
                </NavLink>
              ) : null}
            </div>
          </div>
        </div>

        {/* MODAL AJOUT DE NOUVEAU DE PASSE */}
        <input
          type="checkbox"
          id="modal-add-password"
          className="modal-toggle"
        />
        <div className="modal">
          <div className="modal-box relative rounded-xl">
            <label
              id="modal-add-password"
              htmlFor="modal-add-password"
              className="btn btn-sm bg-black btn-circle absolute right-2 top-2 flex items-center justify-center"
            >
              ✕
            </label>
            <h3 className="text-lg text-center font-bold">
              Définir un mot de passe
            </h3>
            <p className="text-center py-2 text-gray-500">
              Le mot de passe doit contenir au moins 6 caractères
            </p>
            <div className="py-4">
              <input
                disabled={loading}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                placeholder="exemple: azer99"
                className="input w-full bg-gray-mtn rounded-lg"
              />
              <input
                disabled={loading}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                type="password"
                placeholder="exemple: azer99"
                className="input w-full bg-gray-mtn rounded-lg mt-2"
              />
            </div>
            <button
              disabled={loading}
              className="bg-jaune-mtn w-full h-11 rounded-lg font-bold text-sm sm:text-base flex items-center justify-center"
              onClick={addPassword}
            >
              {!loading ? (
                "Enregistrer"
              ) : (
                <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={loading}
                />
              )}
            </button>
            {errorMessage ? (
              <div className="mt-3">
                <p className="text-red-500 font-medium text-center">
                  {errorMessage}
                </p>
              </div>
            ) : null}
          </div>
        </div>

        {/* MODAL DESACTIVER NOUVEAU DE PASSE */}
        <input
          type="checkbox"
          id="modal-remove-password"
          className="modal-toggle"
        />
        <div className="modal">
          <div className="modal-box relative rounded-xl">
            <label
              id="modal-remove-password"
              htmlFor="modal-remove-password"
              className="btn btn-sm bg-black btn-circle absolute right-2 top-2 flex items-center justify-center"
            >
              ✕
            </label>
            <h3 className="text-lg font-bold">Confirmez la désactivation</h3>
            <div className="py-4">
              <input
                disabled={loading}
                value={desactivePassword}
                onChange={(e) => setDesactivePassword(e.target.value)}
                type="password"
                placeholder="Entrez votre mot de passe"
                className="input w-full bg-gray-mtn rounded-lg"
              />
            </div>
            <button
              disabled={loading}
              className="bg-jaune-mtn w-full h-11 rounded-lg font-bold text-sm sm:text-base flex items-center justify-center"
              onClick={desactivatePassword}
            >
              {!loading ? (
                "Désactiver"
              ) : (
                <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={loading}
                />
              )}
            </button>
            {errorMessage ? (
              <div className="mt-3">
                <p className="text-red-500 font-medium text-center">
                  {errorMessage}
                </p>
              </div>
            ) : null}
          </div>
        </div>

        {/* MODAL ALERT SUCCES */}
        <label htmlFor="success-password" id="modal-success"></label>
        <input type="checkbox" id="success-password" className="modal-toggle" />
        <div className="modal">
          <div className="modal-box relative">
            <label
              htmlFor="success-password"
              className="btn btn-sm bg-black flex items-center justify-center btn-circle absolute right-2 top-2"
            >
              ✕
            </label>
            {activationMessage ? (
              <>
                <h3 className="text-2xl text-center text-green-500 font-bold">
                  Succès !
                </h3>
                <p className="py-4 text-center">
                  Votre mot de passe a été defini avec succès
                </p>
              </>
            ) : null}
            {desactivationMessage ? (
              <>
                <h3 className="text-2xl text-center text-green-500 font-bold">
                  Succès !
                </h3>
                <p className="py-4 text-center">
                  Mot de passe désactivé avec succès !
                </p>
              </>
            ) : null}
          </div>
        </div>


        {/* MODAL ALERT PAS UN UTILISATEUR MTN */}
        <input
          type="checkbox"
          id="alert-modal-not-allow"
          className="modal-toggle"
        />
        <div className="modal">
          <div className="modal-box bg-gray-mtn w-11/12 max-w-5xl rounded-md relative">
            <h3 className="text-xl text-center font-bold">Note :</h3>
            <p className="py-4 md:px-16 text-center text-red-500">
              {userNotAllow}
            </p>
          </div>
        </div>

        {/* MODAL ALERT ENTRER UN NUMERO */}
        <input
          type="checkbox"
          id="alert-modal-enter-number"
          className="modal-toggle"
        />
        <div className="modal">
          <div className="modal-box bg-gray-mtn max-w-xl rounded-md relative">
            <h3 className="text-lg sm:text-xl text-center font-bold">
              {message}
            </h3>
            <div className="py-4">
              <label className="label">
                <span className="label-text">Numéro bénéficiaire</span>
              </label>
              <input
                type="number"
                value={userPhoneNumber}
                onChange={(e) => setUserPhoneNumber(e.target.value)}
                placeholder="Ex: 0572443712"
                className="input input-bordered w-full"
              />
            </div>
            <div className="flex justify-center">
              <button
                className="w-full h-11 rounded-lg bg-jaune-mtn font-bold text-black flex items-center justify-center"
                onClick={findUserInfo}
              >
                {!loadingReq ? (
                  "Valider"
                ) : (
                  <ThreeDots
                    height="40"
                    width="40"
                    radius="9"
                    color="#000"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={loadingReq}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profil;
